module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%",
      "background": "#f8f8f8",
      "padding-bottom": "5rem"
    }
  }, [_c('div', {
    staticClass: "check-header"
  }, [_c('div', {
    staticClass: "business-shop-info"
  }, [_c('div', {
    staticClass: "business-shop-box"
  }, [_c('div', {
    staticClass: "shop-name"
  }, [_c('div', {
    staticStyle: {
      "font-size": "19px"
    }
  }, [_vm._v(_vm._s(_vm.row.saiqu.name) + "报名")])])]), _vm._v(" "), _c('div', {
    staticClass: "shop-address"
  }, [_vm._v("请确认培训班信息，选择人员提交报名")]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "delivery-times"
  }, [_c('div', {
    staticClass: "timers-start"
  }, [_c('van-icon', {
    attrs: {
      "name": "clock-o"
    }
  }), _vm._v(" 时间地点\n                    ")], 1), _vm._v(" "), _c('div', {
    staticClass: "timers-end"
  }, [_vm._v(_vm._s(_vm.row.saiqu.province) + _vm._s(_vm.row.saiqu.city) + "(" + _vm._s(_vm.row.saiqu.startdate) + ")")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "20px"
    }
  }), _vm._v(" "), _c('van-divider', [_vm._v("考级信息")]), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "单位",
      "value": _vm.row.apply.danwei
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "联系人",
      "value": _vm.row.apply.name
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "联系方式",
      "value": _vm.row.apply.phone
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "地址",
      "value": _vm.row.apply.address
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "参加人数",
      "value": _vm.row.apply.members
    }
  })], 1), _vm._v(" "), (!_vm.isSubmit) ? _c('van-divider', [_vm._v("人员信息")]) : _vm._e(), _vm._v(" "), (!_vm.isSubmit) ? _c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-cell-group', [_c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '姓名不能为空'
      }],
      "label": "姓名",
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入运动员姓名"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "right-icon": "arrow",
      "input-align": "right",
      "label": "证件类型"
    },
    on: {
      "click": function($event) {
        _vm.showNumTypePicker = true
      }
    },
    model: {
      value: (_vm.formData.numTypeName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "numTypeName", $$v)
      },
      expression: "formData.numTypeName"
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showNumTypePicker),
      callback: function($$v) {
        _vm.showNumTypePicker = $$v
      },
      expression: "showNumTypePicker"
    }
  }, [_c('van-picker', {
    attrs: {
      "columns": _vm.numTypeColumns,
      "show-toolbar": "",
      "default-index": _vm.formData.numtype - 1
    },
    on: {
      "cancel": function($event) {
        _vm.showNumTypePicker = false
      },
      "confirm": _vm.onNumTypeConfirm
    }
  })], 1), _vm._v(" "), (_vm.formData.numtype == 1) ? _c('van-field', {
    attrs: {
      "rules": [{
        validator: _vm.validator.idCard,
        message: '请输入正确的身份证号'
      }],
      "error-message-align": "right",
      "label": "身份证",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入身份证号"
    },
    model: {
      value: (_vm.formData.num),
      callback: function($$v) {
        _vm.$set(_vm.formData, "num", $$v)
      },
      expression: "formData.num"
    }
  }) : _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '护照号不能为空'
      }],
      "error-message-align": "right",
      "label": "护照号",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入护照号"
    },
    model: {
      value: (_vm.formData.num),
      callback: function($$v) {
        _vm.$set(_vm.formData, "num", $$v)
      },
      expression: "formData.num"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    }
  }, [_vm._v("下一步")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isSubmit) ? _c('van-divider', [_vm._v("运动员信息确认")]) : _vm._e(), _vm._v(" "), (_vm.isSubmit) ? _c('van-form', {
    on: {
      "submit": _vm.onConfirm
    }
  }, [_c('van-cell-group', [_c('van-field', {
    attrs: {
      "readonly": "",
      "label": "姓名",
      "input-align": "right"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "label": "证件号",
      "input-align": "right"
    },
    model: {
      value: (_vm.formData.num),
      callback: function($$v) {
        _vm.$set(_vm.formData, "num", $$v)
      },
      expression: "formData.num"
    }
  }), _vm._v(" "), (false) ? _c('van-cell', {
    attrs: {
      "title": "添加证件照片(2寸)"
    }
  }) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "row"
  }, [_c('PicUploader', {
    attrs: {
      "fileList": _vm.formData.pic,
      "limit": 1,
      "name": 'pic'
    }
  })], 1) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("上传2寸免冠照,此照片用于证书粘贴打印")]) : _vm._e(), _vm._v(" "), _c('van-field', {
    attrs: {
      "error-message-align": "right",
      "clearable": "",
      "left-icon": "question-o",
      "rules": [{
        required: true,
        message: '请输入尺码'
      }],
      "label": "衣服尺码",
      "placeholder": "请输入尺码",
      "input-align": "right"
    },
    on: {
      "click-left-icon": function($event) {
        _vm.cSizeShow = true
      }
    },
    model: {
      value: (_vm.formData.csize),
      callback: function($$v) {
        _vm.$set(_vm.formData, "csize", $$v)
      },
      expression: "formData.csize"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left",
    on: {
      "click": function($event) {
        _vm.cSizeShow = true
      }
    }
  }, [_vm._v("查看衣服尺码表")]), _vm._v(" "), _c('van-field', {
    attrs: {
      "name": "radio",
      "label": "性别",
      "input-align": "right"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-radio-group', {
          attrs: {
            "direction": "horizontal"
          },
          model: {
            value: (_vm.formData.sex),
            callback: function($$v) {
              _vm.$set(_vm.formData, "sex", $$v)
            },
            expression: "formData.sex"
          }
        }, [_c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": "男"
          }
        }, [_vm._v("男")]), _vm._v(" "), _c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": "女"
          }
        }, [_vm._v("女")])], 1)]
      },
      proxy: true
    }], null, false, 616011359)
  }), _vm._v(" "), (_vm.row.saiqu.class_type == 'C') ? _c('van-field', {
    attrs: {
      "clearable": "",
      "rules": [{
        required: true,
        message: '请输入鞋码'
      }],
      "error-message-align": "right",
      "label": "鞋  码",
      "placeholder": "请输入鞋码",
      "input-align": "right"
    },
    on: {
      "click-left-icon": function($event) {
        _vm.fSizeShow = true
      }
    },
    model: {
      value: (_vm.formData.footsize),
      callback: function($$v) {
        _vm.$set(_vm.formData, "footsize", $$v)
      },
      expression: "formData.footsize"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.row.saiqu.class_type == 'C') ? _c('div', {
    staticClass: "operate-desc-left",
    on: {
      "click": function($event) {
        _vm.fSizeShow = true
      }
    }
  }, [_vm._v("查看鞋码表")]) : _vm._e(), _vm._v(" "), _c('van-field', {
    attrs: {
      "clearable": "",
      "rules": [{
        validator: _vm.validator.phone,
        message: '请输入正确的手机号'
      }],
      "error-message-align": "right",
      "label": "联系方式",
      "placeholder": "请输入手机号",
      "input-align": "right"
    },
    model: {
      value: (_vm.formData.phone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phone", $$v)
      },
      expression: "formData.phone"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "1rem"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    }
  }, [_vm._v("下一步")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "title": "信息核对",
      "show-cancel-button": ""
    },
    on: {
      "confirm": function($event) {
        return _vm.onConfirmSubmit()
      }
    },
    model: {
      value: (_vm.confirmShow),
      callback: function($$v) {
        _vm.confirmShow = $$v
      },
      expression: "confirmShow"
    }
  }, [_c('van-cell-group', {
    staticStyle: {
      "height": "8rem",
      "overflow-y": "scroll"
    }
  }, [_c('van-field', {
    attrs: {
      "readonly": "",
      "label": "姓名",
      "input-align": "right"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "label": "证件号",
      "input-align": "right"
    },
    model: {
      value: (_vm.formData.num),
      callback: function($$v) {
        _vm.$set(_vm.formData, "num", $$v)
      },
      expression: "formData.num"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "label": "衣服尺码",
      "input-align": "right"
    },
    model: {
      value: (_vm.formData.csize),
      callback: function($$v) {
        _vm.$set(_vm.formData, "csize", $$v)
      },
      expression: "formData.csize"
    }
  }), _vm._v(" "), (_vm.row.saiqu.class_type == 'C') ? _c('van-field', {
    attrs: {
      "readonly": "",
      "label": "鞋  码",
      "input-align": "right"
    },
    model: {
      value: (_vm.formData.footsize),
      callback: function($$v) {
        _vm.$set(_vm.formData, "footsize", $$v)
      },
      expression: "formData.footsize"
    }
  }) : _vm._e(), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "label": "联系方式",
      "input-align": "right"
    },
    model: {
      value: (_vm.formData.phone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phone", $$v)
      },
      expression: "formData.phone"
    }
  })], 1)], 1), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "title": "衣服尺码表"
    },
    model: {
      value: (_vm.cSizeShow),
      callback: function($$v) {
        _vm.cSizeShow = $$v
      },
      expression: "cSizeShow"
    }
  }, _vm._l((_vm.cSizePicList), function(pic, key) {
    return _c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": pic
      },
      on: {
        "click": function($event) {
          return _vm.picShow(key, _vm.cSizePicList)
        }
      }
    })
  }), 0), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "title": "鞋码表"
    },
    model: {
      value: (_vm.fSizeShow),
      callback: function($$v) {
        _vm.fSizeShow = $$v
      },
      expression: "fSizeShow"
    }
  }, [_c('p', {
    staticStyle: {
      "padding": "10px",
      "text-align": "center"
    }
  }, [_vm._v("此鞋型偏小，建议选大一码")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.fSizePicList[0]
    },
    on: {
      "click": function($event) {
        return _vm.picShow(0, _vm.fSizePicList)
      }
    }
  })]), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ecfb6720","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/cba/CbaApplyMemberAdd.vue
// module id = 1334
// module chunks = 0